import { install } from 'ant-design-vue'
import mqtt from 'mqtt'


// 配置选项
const mqttaddress:String=import.meta.env.VITE_MQTT_URL
var options:Object = {
          clean: true, // 是否清除会话
          connectTimeout: 4000, // 连接超时时间
          clientId: 'lanseed_test', // 客户端 ID
          username: 'lanseed', // 用户名
          password: '123456', // 密码
      };
var client=null;
export const mqttstart:Object=(userid:String,app:ComponentInternalInstance,mqttSeverUrl:String=null)=>{
        options.clientId=userid
        if(mqttSeverUrl==null){
          client = mqtt.connect(mqttaddress,options)
        }else{
          client = mqtt.connect(mqttSeverUrl,options)
        }
        const that=app.appContext.config.globalProperties
        client.on('connect', () => {
          onStateChange(true)
          client.subscribe('internal/v1/gateway/telemetry/#', { qos: 0 }, (err) => {
            if (!err) {
              console.log('订阅成功:internal/v1/gateway/telemetry/#');
            }
            });
          client.subscribe('internal/v1/gateway/devicestate/#', { qos: 0 }, (err) => {
            if (!err) {
              console.log('订阅成功:internal/v1/gateway/devicestate/#');
            }
            });
          that.$emit("mqttconnect",true)
        })
        client.on('close',()=>{
          onStateChange(false)
          that.$emit("mqttconnect",false)

        })
        client.on('message',(topic, message) => {
          var m=JSON.parse(message.toString())
          that.$emit("mqttdata",topic,m)
          onMessage(topic,m)
          //console.log('mqtt消息：',topic,m);
        })
        return client
      }
export const onMessage=(topic:string,message:any)=>{

      }
export const onStateChange=(state:boolean)=>{

      }
export const close=()=>{
        if(client!=null&&client.connected){
          client.end()
        }
      }
export const isConnect=()=>{
  if(client==null){return false}
  return client.connected
}
